import RequestAbstract from "../abstract";

export default class CouponTransactions extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/coupon-transactions";
    }
}
